import DashboardPage from "./Pages/DashboardPage/DashboardPage";
import OptionsPage from "./Pages/OptionsPage/OptionsPage";
import LoginPage from "./Pages/LoginPage/LoginPage";
import AdminPage from "./Pages/AdminPage/AdminPage";
// Import the new page
import NotFoundPage from "./Pages/NotFoundPage/NotFoundPage"; 

export const Routes = {
  HOME_PAGE: "/",
  LOGIN_PAGE: "/login",
  DASHBOARD_PAGE: "/dashboard",
  OPTIONS_PAGE: "/options",
  ADMIN_PAGE: "/administration",
  NOT_FOUND: "*"
};

export const BackToAppDeepLink = "csistatusmon://logout";
export const TriggerNotificationSettingsLink = "csistatusmon://notifications/enabled";

export const PagesRoutes = [
  {
    path: Routes.HOME_PAGE,
    component: <LoginPage />,
    requiresAuth: false,
  },
  {
    path: Routes.LOGIN_PAGE,
    component: <LoginPage />,
    requiresAuth: false,
  },
  {
    path: Routes.DASHBOARD_PAGE,
    component: <DashboardPage />,
    requiresAuth: true,
  },
  {
    path: Routes.OPTIONS_PAGE,
    component: <OptionsPage />,
    requiresAuth: true,
  },
  {
    path: Routes.ADMIN_PAGE,
    component: <AdminPage />,
    requiresAuth: true,
  },
  {
    path: Routes.NOT_FOUND,
    component: <NotFoundPage />,
    requiresAuth: false, 
  },
];